import { createSelector } from 'reselect';
import { IRootState } from 'store';

export const selectorGetActiveCodingProject = createSelector(
    (state: IRootState) => state.coding, 
    (coding) => coding.codingProjects[coding.activeProjectIndex]
);